export const PUBLIC_METADATA_KEY = '__metadata';
export const DEFAULT_API_URL = 'www.wixapis.com';
export const DEFAULT_EDGE_API_URL = 'edge.wixapis.com';
export const FORCE_WRITE_API_URLS = ['/ecom/v1/carts/current'];
